import {
    DADATA_FORM_FIELDS_MAP,
    FIELDS_FOR_PLEDGE_AUTO,
    FIELDS_FOR_PLEDGE_REALTY,
    REQUIRED_FIELDS_FOR_PLEDGE_AUTO_UPDATE,
    REQUIRED_FIELDS_FOR_PLEDGE_REALTY_UPDATE,
    REQUIRED_FIELDS_FOR_PROFILE_PEOPLE_UPDATE,
} from '../../../../constants';

export const checkProfileDataHasAllRequiredFields = (data: FE.FormData, requiredFields: Array<string>) => {
    return requiredFields.every((key) => data[key] || typeof data[key] === 'number');
};
export const checkUpdateDataHasAnyRequiredFields = (formData: FE.FormData) => {
    return REQUIRED_FIELDS_FOR_PROFILE_PEOPLE_UPDATE.some((key) => formData[key] || typeof formData[key] === 'number');
};

/*
    Если в обновленных полях есть поле, связанное с адресом,
    то в обновление добавлять объект Dadata из общего состояния формы
 */
export const addAddressDadataFields = (update: FE.FormData, currentForm: FE.FormData) => {
    const updateFields = Object.keys(update);
    Object.keys(DADATA_FORM_FIELDS_MAP).forEach((dadataField) => {
        if (DADATA_FORM_FIELDS_MAP[dadataField].some((addressField) => updateFields.includes(addressField))) {
            if (currentForm[dadataField]) {
                update[dadataField] = currentForm[dadataField];
            }
        }
    });
};

/*
    Если в обновленных полях есть поле, связанное с адресом, но объекта Dadata нет,
    то удалить поле из обновления (т к gql не сможет сохранить новые данные без обязательного fiasId)
 */
export const removeAddressFieldsWithoutDadata = (update: FE.FormData) => {
    const updateFields = Object.keys(update);
    Object.keys(DADATA_FORM_FIELDS_MAP).forEach((dadataField) => {
        if (DADATA_FORM_FIELDS_MAP[dadataField].some((addressField) => updateFields.includes(addressField))) {
            if (!update[dadataField]) {
                DADATA_FORM_FIELDS_MAP[dadataField].forEach((removeField) => {
                    delete update[removeField];
                });
            }
        }
    });
};

/*
    Если в обновленных полях есть поля залога, но нет обязательных, то добавить обязательные поля
 */
export const addRequiredPledgeFields = (update: FE.FormData, currentForm: FE.FormData) => {
    const updateFields = Object.keys(update);
    const updatedAutoPledgeFields = FIELDS_FOR_PLEDGE_AUTO.filter((field) => updateFields.includes(field));
    const updatedRealtyPledgeFields = FIELDS_FOR_PLEDGE_REALTY.filter((field) => updateFields.includes(field));

    if (updatedAutoPledgeFields.length > 0) {
        const hasAllRequiredFields = checkProfileDataHasAllRequiredFields(
            currentForm,
            REQUIRED_FIELDS_FOR_PLEDGE_AUTO_UPDATE,
        );
        if (hasAllRequiredFields) {
            REQUIRED_FIELDS_FOR_PLEDGE_AUTO_UPDATE.forEach((requiredField) => {
                if (!update[requiredField]) {
                    update[requiredField] = currentForm[requiredField];
                }
            });
        }
    }

    if (updatedRealtyPledgeFields.length > 0) {
        const hasAllRequiredFields = checkProfileDataHasAllRequiredFields(
            currentForm,
            REQUIRED_FIELDS_FOR_PLEDGE_REALTY_UPDATE,
        );
        if (hasAllRequiredFields) {
            REQUIRED_FIELDS_FOR_PLEDGE_REALTY_UPDATE.forEach((requiredField) => {
                if (!update[requiredField]) {
                    update[requiredField] = currentForm[requiredField];
                }
            });
        }
    }
};

/*
    Если в обновленных полях залога нет обязательных, то удалять все полях залога из обновления
 */
export const removePledgeFieldsWithoutRequired = (update: FE.FormData) => {
    const updateFields = Object.keys(update);
    const updatedAutoPledgeFields = FIELDS_FOR_PLEDGE_AUTO.filter((field) => updateFields.includes(field));
    const updatedRealtyPledgeFields = FIELDS_FOR_PLEDGE_REALTY.filter((field) => updateFields.includes(field));

    if (updatedAutoPledgeFields.length > 0) {
        const hasAllRequiredFields = checkProfileDataHasAllRequiredFields(
            update,
            REQUIRED_FIELDS_FOR_PLEDGE_AUTO_UPDATE,
        );
        if (!hasAllRequiredFields) {
            FIELDS_FOR_PLEDGE_AUTO.forEach((autoPledgeField) => {
                delete update[autoPledgeField];
            });
        }
    }

    if (updatedRealtyPledgeFields.length > 0) {
        const hasAllRequiredFields = checkProfileDataHasAllRequiredFields(
            update,
            REQUIRED_FIELDS_FOR_PLEDGE_REALTY_UPDATE,
        );
        if (!hasAllRequiredFields) {
            FIELDS_FOR_PLEDGE_REALTY.forEach((realtyPledgeField) => delete update[realtyPledgeField]);
        }
    }
};
